import { useCallback } from 'react'

export const useGetDaysBetweenDates = () => {
  const getDaysBetweenDates = useCallback((timestamp1, timestamp2) => {
    const earlerDay = new Date(timestamp1).getTime()
    const laterDay = new Date(timestamp2).getTime()
    const diffDays = Math.round((laterDay - earlerDay) / (60 * 60 * 24))
    return diffDays
  }, [])

  return { getDaysBetweenDates }
}
